import isMobile from './isMobile';

const objectPrefix = (normalIndex = null, mobileIndex = null) => {
    if (isMobile()) {
        return mobileIndex !== null ? `mobile-${mobileIndex}` : 'mobile';
    }

    return normalIndex !== null ? `normal-${normalIndex}` : 'normal';
};

export default objectPrefix;



// WEBPACK FOOTER //
// ./js/lib/objectPrefix.js